export default __webpack_public_path__ + "static/media/nouman.a5a5fa1b.jpg";